import { useI18n } from '../i18n/index.jsx';

export default function Loading({ text }) {
  const { t } = useI18n();
  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      <p>{text || t('common.loading')}</p>
    </div>
  );
}
